export default __webpack_public_path__ + "images/3b356e78646a47ccc156325c4afb41fc-jazz_small.webp";